import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles/theme.css';
import SeoAnalytics from './SeoAnalytics.js';

const HomePage = React.lazy(() => import('./pages/HomePage.js'));
const PrivacyPage = React.lazy(() => import('./pages/PrivacyPage.js'));
const TermsPage = React.lazy(() => import('./pages/TermsPage.js'));

function Loading() {
  return (
    <div style={{
      background: 'var(--bg-page)', minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: 'var(--text-muted)', fontFamily: 'var(--font-core)'
    }}>
      Loading perashoot...
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SeoAnalytics />
      <React.Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}